import ArticleSelect from './inputs/ArticleSelect';
import SupplierSelect from './inputs/generated/SupplierSelect';
import BrandSelect from './inputs/generated/BrandSelect';
import OrderSelect from './inputs/generated/OrderSelect';
import UserSelect from './inputs/generated/UserSelect';
import OrganizationSelect from './inputs/generated/OrganizationSelect';
import PurchaseOrderSelect from './inputs/generated/PurchaseOrderSelect';
import CustomerSubUnitSelect from './inputs/generated/CustomerSubUnitSelect';
import PriceListSelect from './inputs/generated/PriceListSelect';
import InvoiceSelect from './inputs/generated/InvoiceSelect';
import ShopConfigSelect from './inputs/generated/ShopConfigSelect';

export {
  SupplierSelect,
  BrandSelect,
  OrderSelect,
  UserSelect,
  OrganizationSelect,
  PurchaseOrderSelect,
  CustomerSubUnitSelect,
  ArticleSelect,
  PriceListSelect,
  InvoiceSelect,
  ShopConfigSelect,
};
